/** Gift-finder product tags — normalized slug list on each product. */

export const AUTO_PRODUCT_TAG_SLUGS = ['new', 'bestseller'];

export function normalizeGiftTagSlug(raw) {
  return String(raw || '')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9-]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

/**
 * @param {unknown} raw — array or comma/newline string
 * @returns {string[]}
 */
export function normalizeProductGiftTags(raw) {
  let parts = [];
  if (Array.isArray(raw)) {
    parts = raw;
  } else if (typeof raw === 'string' && raw.trim()) {
    parts = raw.split(/[,;\n]+/);
  }
  const out = new Set();
  for (const t of parts) {
    const s = normalizeGiftTagSlug(t);
    if (s && s !== 'all') out.add(s);
  }
  return [...out];
}

/** Remove auto-managed slugs from manual gift tag input. */
export function stripManualAutoTags(raw) {
  const manual = normalizeProductGiftTags(raw);
  return manual.filter((t) => !AUTO_PRODUCT_TAG_SLUGS.includes(t));
}

/** @param {unknown} raw */
export function normalizeHiddenAutoTags(raw) {
  const allowed = new Set(AUTO_PRODUCT_TAG_SLUGS);
  const list = normalizeProductGiftTags(raw);
  return list.filter((t) => allowed.has(t));
}

/** @param {string[]} hidden @param {string} tag @param {boolean} shouldHide */
export function setHiddenAutoTag(hidden, tag, shouldHide) {
  const slug = normalizeGiftTagSlug(tag);
  if (!AUTO_PRODUCT_TAG_SLUGS.includes(slug)) return normalizeHiddenAutoTags(hidden);
  const set = new Set(normalizeHiddenAutoTags(hidden));
  if (shouldHide) set.add(slug);
  else set.delete(slug);
  return [...set];
}

/** @param {object} product */
export function productGiftTags(product) {
  return normalizeProductGiftTags(product?.gift_tags);
}

/** @param {object} product @param {string} tagSlug */
export function productHasGiftTag(product, tagSlug) {
  const t = normalizeGiftTagSlug(tagSlug);
  if (!t) return false;
  return productGiftTags(product).includes(t);
}

/** @param {object} product @param {string[]} tagSlugs */
export function productMatchesAnyGiftTag(product, tagSlugs) {
  const want = (tagSlugs || []).map(normalizeGiftTagSlug).filter(Boolean);
  if (!want.length) return true;
  const have = new Set(productGiftTags(product));
  return want.some((t) => have.has(t));
}
